import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button, Box, Breadcrumbs, Typography } from '@mui/material/'

import { Circle } from '@mui/icons-material'
import { FormStatusType } from '@/enums/form-status.enum'
import routes from '@/routes'

import Main from '@/views/layouts/main'
import ErrorLimit from '@/views/components/error-limit/index.component'
import { useWalletsDialog, useWalletsActions } from '@/views/wallets/hooks'

import WalletsModule from '@/views/wallets/index.module'
import PageTitle from '@/views/layouts/page-title/index.layout'
import { DialogsEnum } from '@/enums'

const WalletsPage = () => {
  const { t } = useTranslation()

  const { toggleDialog } = useWalletsDialog()

  const { setFormType } = useWalletsActions()

  const handleSetWallet = () => {
    setFormType(FormStatusType.CREATE)
    toggleDialog({
      open: true,
      id: DialogsEnum.DIALOG_MANUAL_BONUS,
    })
  }

  const breadcrumbs = (
    <Breadcrumbs separator={<Circle sx={{ fontSize: 6, marginX: 2 }} />}>
      <Link to={routes.HOME}>
        <Typography>{t('pages.home')}</Typography>
      </Link>
      <Typography>{t('pages.bonusEngine')}</Typography>
      <Typography>{t('pages.wallet')}</Typography>
    </Breadcrumbs>
  )

  return (
    <Main>
      <ErrorLimit>
        <Box display="flex" mb={5}>
          <PageTitle title={t('pages.wallet')} breadcrumbs={breadcrumbs} />
          <Box display="flex" alignItems="center" flexShrink={0}>
            <Button
              onClick={handleSetWallet}
              variant="contained"
              color="primary"
            >
              {t('wallet.setNewWallet')}
            </Button>
          </Box>
        </Box>
        <WalletsModule />
      </ErrorLimit>
    </Main>
  )
}

export default WalletsPage
